import React from 'react';
// @ts-ignore
import HighchartsReact from 'highcharts-react-official';
// @ts-ignore
import Highcharts from 'highcharts';
// @ts-ignore
import HC_more from 'highcharts/highcharts-more';
// @ts-ignore
import dayjs from 'dayjs';
import './Chart.css';
import Tooltip from 'src/components/common/Dynamic-old/Tooltip';
HC_more(Highcharts);

// const demoData = [
//     {
//         "EmployeeId": 10825,
//         "Date": "2021-04-03T00:00:00",
//         "DepartmentId": 2300,
//         "DepartmentDescription": "Phoenix",
//         "TimesheetHours": 0.0,
//         "FieldTimeCodeId": 139,
//         "TimesheetDescription": "Call Out",
//         "TimesheetTotalHours": 5.0,
//         "TimeEntryComment": null,
//         "UserModified": false,
//         "UserTimesheetHours": 0.0,
//         "StartDate": "2021-04-03T04:45:53",
//         "EndDate": "2021-04-03T10:00:56",
//         "UTCOffset": -7
//     },
// ]

interface IProps {
    data: any;
    date: number;
}

const Chart = (props: IProps) => {
    const chart = React.useRef() as any;
    const [graphData, setGraphData] = React.useState([] as any);
    const [categories, setCategories] = React.useState([] as any);
    const [plotLines, setPlotLines] = React.useState([] as any);

    const attachTooltipEvents = () => {
        const flags = document.querySelectorAll('.tt, .tt-left');
        console.log('attachTooltipEvents fired, flags found:', flags.length);

        flags.forEach((el) => {
            const tooltip = el.querySelector('.tt-text') as HTMLElement;
            console.log('flag el:', el, 'tooltip el:', tooltip);
            if (!tooltip) return;

            // Force overflow visible on all ancestors up to highcharts-container
            let parent = el.parentElement;
            while (parent) {
                (parent as HTMLElement).style.overflow = 'visible';
                if (parent.classList.contains('highcharts-container')) break;
                parent = parent.parentElement;
            }

            const clone = el.cloneNode(true) as HTMLElement;
            el.parentNode?.replaceChild(clone, el);
            const clonedTooltip = clone.querySelector('.tt-text') as HTMLElement;

            clone.addEventListener('mouseenter', () => {
                console.log('mouseenter fired');
                clonedTooltip.style.visibility = 'visible';
                clonedTooltip.style.opacity = '1';
            });
            clone.addEventListener('mouseleave', () => {
                clonedTooltip.style.visibility = 'hidden';
                clonedTooltip.style.opacity = '0';
            });
        });

        // Also force overflow on the SVG itself
        document.querySelectorAll('.highcharts-container, .highcharts-root, .highcharts-plot-border').forEach((el) => {
            (el as HTMLElement).style.overflow = 'visible';
            el.setAttribute('overflow', 'visible');
        });
    };

    React.useEffect(() => {
        let grouped: any = {};
        let plotlines: any = [];
        let cats: any = [];

        props.data.forEach((item: any) => {
            if (item.category !== "FirstLastSync") {
                if (!grouped[item.category]) {
                    grouped[item.category] = {};
                    grouped[item.category].data = [];
                    grouped[item.category].color = item.colorHex;
                    cats.push(item.category);
                }
                grouped[item.category].data.push({
                    x: cats.findIndex((i: any) => i === item.category),
                    low: dayjs(item.startts).valueOf(),
                    high: dayjs(item.endts).valueOf(),
                    color: item.colorHex
                });
            }

            if (item.category === "FirstLastSync") {
                plotlines.push({
                    width: 1,
                    value: dayjs(item.startts).valueOf(),
                    color: "red",
                    label: {
                        // text: `Start: ${dayjs(item.startts).format("MM/DD/YYYY hh:mmA")}`, 
                        zIndex: 5,
                        align: "left",
                        width: 1,
                        formatter: function () {
                            return `
                                <div style="width:20px;height:20px;margin-top:17px;transform:rotate(-90deg);overflow:visible;position:relative;cursor:pointer;" class="bg-danger tt">
                                    <span class="tt-text" style="
                                        visibility:hidden;
                                        opacity:0;
                                        position:absolute;
                                        top:24px;
                                        left:0;
                                        white-space:nowrap;
                                        background:rgba(0,0,0,0.85);
                                        color:#fff;
                                        font-size:13px;
                                        font-weight:600;
                                        padding:8px 14px;
                                        border-radius:4px;
                                        box-shadow:0 2px 6px rgba(0,0,0,0.4);
                                        z-index:9999;
                                        pointer-events:none;
                                        transition:opacity 0.15s ease;
                                    ">${dayjs(item.startts).format("hh:mm A")}</span>
                                </div>`;
                        },
                        useHTML: true
                    },
                    zIndex: 100,
                });

                plotlines.push({
                    width: 1,
                    value: dayjs(item.endts).valueOf(),
                    color: "green",
                    label: {
                        zIndex: 5,
                        width: 1,
                        formatter: function () {
                            return `
                                <div style="width:20px;height:20px;margin-top:-3px;transform:rotate(-90deg);overflow:visible;position:relative;cursor:pointer;" class="bg-success tt-left">
                                    <span class="tt-text" style="
                                        visibility:hidden;
                                        opacity:0;
                                        position:absolute;
                                        top:24px;
                                        left:0;
                                        white-space:nowrap;
                                        background:rgba(0,0,0,0.85);
                                        color:#fff;
                                        font-size:13px;
                                        font-weight:600;
                                        padding:8px 14px;
                                        border-radius:4px;
                                        box-shadow:0 2px 6px rgba(0,0,0,0.4);
                                        z-index:9999;
                                        pointer-events:none;
                                        transition:opacity 0.15s ease;
                                        left:auto;
                                        right:0;
                                    ">${dayjs(item.endts).format("hh:mm A")}</span>
                                </div>`;
                        },
                        useHTML: true
                    },
                    zIndex: 100,
                });
            }

        });
        // console.log("ModifiedData: ", grouped, plotlines);
        // console.log("Graph Data: ", Object.keys(grouped).map((cat: string) => ({
        //     name: cat,
        //     stack: cat,
        //     data: grouped[cat].data,
        //     // color: grouped[cat].color
        // })));
        setCategories(cats);
        setGraphData(Object.keys(grouped).map((cat: string) => ({
            name: cat,
            stack: cat,
            data: grouped[cat].data,
            color: grouped[cat].color
        })));
        setPlotLines(plotlines);
        //eslint-disable-next-line
    }, []);



    return (
        <div className=''>
            <div className='d-flex flex-row'>
                <div className='col'></div>
                <div className="col d-flex justify-content-center">
                    <h5>{dayjs(props.date).format("MM/DD/YYYY")}</h5>
                </div>
                <div className='infoDiv col d-flex justify-content-end'>
                    <Tooltip name="TT-Admin-Analysis" />
                </div>
            </div>

            <HighchartsReact
                highcharts={Highcharts}
                options={{
                    chart: {
                        type: 'columnrange',
                        inverted: true,
                        height: 250,
                        width: 475,
                        events: {
                            render: attachTooltipEvents
                        }
                    },
                    title: {
                        // text: `${dayjs(props.date).format("MM/DD/YYYY")}`,
                        text: ""
                    },
                    xAxis: {
                        categories: categories,
                    },
                    yAxis: {
                        labels: {
                            //!!!r-18-dj
                            //@ts-ignore
                            formatter: function () { return dayjs(this.value).format("h A"); }
                        },
                        min: dayjs(props.date).hour(5).minute(0).second(0).valueOf(),
                        max: dayjs(props.date).hour(26).minute(0).second(0).valueOf(),
                        tickInterval: 1000 * 60 * 60 * 2,
                        plotLines,
                        title: {
                            text: `<div class="d-flex flex-column align-items-center justify-content-center">
                                <h6>Time of Day</h6>
                                <span class="text-orange">(Employee Local Time)</span>
                            </div>`,
                            textAlign: "center",
                            useHTML: true
                        }
                    },
                    plotOptions: {
                        columnrange: {
                            grouping: false,
                            groupPadding: 0,
                            maxPointWidth: 26,
                            pointPadding: 0,
                        },
                        series: {
                            dataLabels: {
                                enabled: true,
                                inside: true,
                                align: "center",
                                crop: true,
                                overflow: "justify",
                                // style: {
                                //     textShadow: "false",
                                //     textOutline: "false"
                                // },
                                //!!!r-18-dj
                                //@ts-ignore
                                formatter: function () {
                                    //!!!r-18-dj
                                    //@ts-ignore
                                    // console.log("DATALABEL FORMATTER: ", this.color, this.point);
                                    //!!!r-18-dj
                                    //@ts-ignore
                                    return `${Math.ceil((dayjs(this.point.high).diff(dayjs(this.point.low), "m") / 60) / 0.25) * 0.25}hrs`;
                                }
                            }
                        },
                    },
                    series: graphData,
                    tooltip: {
                        //!!!r-18-dj
                        //@ts-ignore
                        formatter: function () {
                            console.log("THIS for tooltip: ", this);
                            //!!!r-18-dj
                            //@ts-ignore
                            return `${this.key}: ${dayjs(this.point.low).format("hh:mm A")} - ${dayjs(this.point.high).format("hh:mm A")}`;
                        }
                    },
                    legend: {
                        enabled: false,
                        align: "center",
                        verticalAlign: "bottom",
                    },
                    credits: { enabled: false },
                }}
                ref={chart}
                allowChartUpdate={true}
            />
        </div>
    );
}

// const entryData: any = graphData.find((e: any) => e.name === this.name)?.data;
// let total: number = entryData?.reduce((acc: number, timeEntry: any) => acc + (timeEntry.high - timeEntry.low), 0) || 0;
// let timeValue: number = total / (1000 * 60 * 60);

export default Chart;